import React from 'react';

/**
 * QwickMed Logo — Professional Redesign
 * 
 * Icon: A bold circular mark with a stylized Q that doubles as a
 *       medical cross and has a lightning bolt tail — symbolising
 *       "fast, genuine medicine."
 * 
 * Wordmark: Clean, single-weight, dark navy — no rainbow gradients.
 *           One accent colour (cyan) on "Med" only.
 */

const Logo = ({ className = "" }) => {
    return (
        <div className={`flex items-center gap-2 ${className}`}>

            {/* ── ICON MARK ──────────────────────────────────── */}
            <img
                src="/logo192.png"
                alt="QwickMed"
                width="44"
                height="44"
                style={{ flexShrink: 0, borderRadius: '8px' }}
            />

            {/* ── WORDMARK ──────────────────────────────────── */}
            <div style={{ lineHeight: 1, userSelect: 'none' }}>
                <div style={{
                    fontSize: '1.45rem',
                    fontWeight: 900,
                    letterSpacing: '-0.04em',
                    color: '#0f172a',
                    fontFamily: "'Inter', 'Segoe UI', sans-serif",
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '0',
                }}>
                    <span>Qwick</span>
                    <span style={{ color: '#0ea5e9' }}>Med</span>
                </div>
                <div style={{
                    fontSize: '0.5rem',
                    fontWeight: 700,
                    letterSpacing: '0.18em',
                    textTransform: 'uppercase',
                    color: '#94a3b8',
                    marginTop: '2px',
                    fontFamily: "'Inter', 'Segoe UI', sans-serif",
                }}>
                    Online Pharmacy
                </div>
            </div>
        </div>
    );
};

export default Logo;
